import React from "react";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";
import { Button, Menu, MenuItem } from "@mui/material";

const SelectedStreamDropDown = () => {
  const {
    cameraStreams,
    cameraStreamsSelectedIndex,
    setCameraStreamsSelectedIndex,
  } = useEditCameraStore();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!cameraStreams) return null;

  return (
    <div className="flex border-b-[1px] pb-[10px] border-gray-300">
      <p className="text-actuate-blue font-mulish font-bold text-[16px] pt-[15px] pl-[15px]">
        Selected Stream:
      </p>
      <div className="pl-[10px] pt-[10px]">
        <div className="text-actuate-blue font-mulish text-[16px]">
          <Button
            id="stream-selector"
            aria-controls={open ? "stream-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            {cameraStreams[cameraStreamsSelectedIndex]?.name}
          </Button>
          <Menu
            id="schedule-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "schedule-selector",
            }}
          >
            {cameraStreams.map((stream, index) => (
              <MenuItem
                key={stream.name}
                onClick={() => {
                  setCameraStreamsSelectedIndex(index);
                  handleClose();
                }}
              >
                {stream.name}
              </MenuItem>
            ))}
          </Menu>
        </div>
      </div>
      <p className="text-actuate-blue font-mulish font-bold text-[16px] pt-[15px] pl-[35px]">
        Stream Products:
      </p>
      <p className="text-actuate-blue font-mulish font-bold text-[16px] pt-[15px] pl-[35px]">
        {cameraStreams[cameraStreamsSelectedIndex]?.product || "--"}
      </p>
    </div>
  );
};

export default SelectedStreamDropDown;
